import React from "react";
import _ from "lodash";

import InputFile from "components/InputFile";
import getVar from "constants/.";

import "./style";

const EXTENSIONS = ["jpg", "jpeg", "gif", "png", "bmp"];

interface IProps {
  file?: File | string;
  label?: string;
  onChange: (file?: File) => void;
}

interface IState {
  value?: File;
}

class InputImage extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    const { file } = props;
    this.state = { value: file };
  }

  public componentWillReceiveProps(nextProps) {
    const { file } = nextProps;

    if (file !== this.props.file) {
      this.setState({ value: file });
    }
  }

  private handleImageChange = ([file]) => {
    const { onChange } = this.props;

    this.setState({ value: file });
    onChange(file);
  };

  private handleImageRemove = i => {
    this.setState({ value: undefined });
    this.props.onChange(undefined);
  };

  public render() {
    const { value } = this.state;
    const { ...props } = this.props;
    const imageSrc = _.isObject(value)
      ? URL.createObjectURL(value)
      : `${getVar("LOCAL_API_URI")}/images/${value}`;

    return (
      <div className="fi-image-wrapper">
        <div>
          <div className="fi-image">{value && <img src={imageSrc} />}</div>
          <InputFile
            {...props}
            name="image"
            multiple={false}
            files={value && [value]}
            extensions={EXTENSIONS}
            onChange={this.handleImageChange}
            remove={this.handleImageRemove}
          />
        </div>
      </div>
    );
  }
}

export default InputImage;
